import React, { useEffect } from 'react';
import { useStore } from '../../../../stores/root';

// assets

// services

// props

// components
import { Stack } from '@fluentui/react';
import EmployeeContractsList from '../../../hr/contracts/general/list';

type MyContractsListProps = {

}

const MyContractsList: React.FC<MyContractsListProps> = (props: MyContractsListProps) => {
    const {user} = useStore();

    return <Stack>
        {user.data ? <EmployeeContractsList qs={['employee_id=' + user.data.id]}
            columns={['id', 'subsidiary', 'startDate', 'endDate', 'status']}
            hideCommandBar /> : null}
    </Stack>
};

export default MyContractsList;
